/**
 * Public share pages (/share/Dashboard/<hash>, /share/DashboardData/<hash>,
 * /share/insights/<hash>) load dashboard widgets without a login. The API only
 * serves a shared dashboard to requests that carry its share hash, so knowing a
 * dashboard id is not enough to read it; apiRequest sends the hash in this header.
 */
export const SHARE_HASH_HEADER = "X-Pivony-Share";

const SHARE_PATH = /^\/share\/(?:Dashboard|DashboardData|insights)\/([^/?#]+)/;

export const currentShareHash = (
  pathname = typeof window !== "undefined" ? window.location.pathname : ""
) => {
  const match = SHARE_PATH.exec(pathname || "");
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch (_) {
    return match[1];
  }
};
